module.exports = __webpack_public_path__ + "img/girl_and_mom.d33e4d02.png";